const category = {
    state:{
      classifyId: { // 分类
        className: '',
        id: ''
      },
    },
    mutations:{
      CLASSIFYID: (state,item) => {
        state.classifyId = item
      },
    },
    actions:{
        
    }
  }
  export default category